// src/pages/vouchers/VoucherDetailPage/VoucherDetailPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import VouchersAPI, { normalizeVoucher } from "../../../api/v3/vouchers-api-v3";

const BASE = "/app/sales/bagspa";

const fmtRp = (n) =>
  n === null || n === undefined || n === ""
    ? "-"
    : `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

const yesNo = (v) => (v ? "Yes" : "No");

export default function VoucherDetailPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setErr("");
      try {
        // Backend returns { item: {...} }
        const data = await VouchersAPI.show(id);
        const raw = data?.item ?? data ?? {};
        // Normalize common fields (booleans, scope, etc.)
        const base = normalizeVoucher(raw);
        // Keep extra fields that the normalizer intentionally leaves passthrough
        const merged = {
          ...base,
          maximum_discount_value: raw.maximum_discount_value,
          minimum_transaction_value: raw.minimum_transaction_value,
          updated_at: raw.updated_at,
        };
        setItem(merged);
      } catch (e) {
        setErr(e.message || "Failed to load voucher");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="mb-0">Voucher Detail</h2>
        <div className="d-flex gap-2">
          <Link className="btn btn-outline-secondary" to={`${BASE}/vouchers`}>Back</Link>
          <Link className="btn btn-primary" to={`${BASE}/vouchers/${id}/edit`}>Edit</Link>
        </div>
      </div>

      {loading && <div>Loading…</div>}
      {err && <div className="alert alert-danger">{err}</div>}

      {item && (
        <div className="card shadow-sm">
          <div className="card-body">
            <dl className="row">
              <dt className="col-sm-3">Code</dt>
              <dd className="col-sm-9">{item.code}</dd>

              <dt className="col-sm-3">Type</dt>
              <dd className="col-sm-9">{item.discount_type}</dd>

              <dt className="col-sm-3">Value</dt>
              <dd className="col-sm-9">
                {item.discount_type === "percentage"
                  ? `${item.discount_value}%`
                  : fmtRp(item.discount_value)}
              </dd>

              <dt className="col-sm-3">Max Discount</dt>
              <dd className="col-sm-9">{fmtRp(item.maximum_discount_value)}</dd>

              <dt className="col-sm-3">Min Transaction</dt>
              <dd className="col-sm-9">{fmtRp(item.minimum_transaction_value)}</dd>

              <dt className="col-sm-3">Scope</dt>
              <dd className="col-sm-9">{item.applies_to_scope || "all_items"}</dd>

              {Array.isArray(item.category_codes) && item.category_codes.length > 0 && (
                <>
                  <dt className="col-sm-3">Product Categories</dt>
                  <dd className="col-sm-9">
                    {item.category_codes.map((c) => (
                      <span key={c} className="badge bg-light text-dark me-2">{c}</span>
                    ))}
                  </dd>
                </>
              )}

              {Array.isArray(item.order_category_codes) && item.order_category_codes.length > 0 && (
                <>
                  <dt className="col-sm-3">Order Categories</dt>
                  <dd className="col-sm-9">
                    {item.order_category_codes.map((c) => (
                      <span key={c} className="badge bg-light text-dark me-2">{c}</span>
                    ))}
                  </dd>
                </>
              )}

              <dt className="col-sm-3">Active</dt>
              <dd className="col-sm-9">{yesNo(item.active)}</dd>

              <dt className="col-sm-3">Expiration</dt>
              <dd className="col-sm-9">
                {item.expiration_date ? new Date(item.expiration_date).toLocaleString() : "-"}
              </dd>

              <dt className="col-sm-3">Promo Text</dt>
              <dd className="col-sm-9">{item.promotional_text || "-"}</dd>

              <dt className="col-sm-3">Created</dt>
              <dd className="col-sm-9">
                {item.created_at ? new Date(item.created_at).toLocaleString() : "-"}
              </dd>

              <dt className="col-sm-3">Updated</dt>
              <dd className="col-sm-9">
                {item.updated_at ? new Date(item.updated_at).toLocaleString() : "-"}
              </dd>
            </dl>
          </div>
        </div>
      )}
    </div>
  );
}
